module.exports = __webpack_public_path__ + "static/media/big_thumbs_down.a1e477a0.jpg";